import React from "react";

import ContactsDrilldown from "./ContactsDrilldown";

const Contacts = () => {
  return <ContactsDrilldown />;
}

export default Contacts;
